import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

import { isPwa } from "helpers/pwa_utils";
import { makeLogger } from "helpers/pwa_logger";

const log = makeLogger("session_upgrade");

export default class extends Controller {
  static values = {
    isPwaOverride: Boolean,
    isPwaSession: Boolean,
    path: String,
  };

  static targets = ["form"];

  async connect() {
    log("session_upgrade_controller connected");

    if ((await this.#isPwa()) && !this.isPwaSessionValue) {
      log("Detected PWA mode without a PWA session. Upgrading session...");

      this.formTarget.submit();
    }
  }

  // Wrapper for `isPwa` to allow changing the value in the test env
  // TODO: Set up real installed-app tests so we don't have to do this hacky override stuff
  async #isPwa() {
    let isPwaMode = await isPwa(); // Always run the standard detection
    if (this.isPwaOverrideValue) {
      return true;
    } else {
      return isPwaMode;
    }
  }
}
